import React from 'react';
import { Modal, Radio, Select } from 'antd';
import { translate } from 'react-i18next';
import { compose } from 'redux';
const RadioGroup = Radio.Group;
const Option = Select.Option;

class ModalFilter extends React.Component {

  constructor() {
    super();
    this.state = {
      grades: null,
      subjecCategories: null,
      grade: 'All',
      category: 'All',
      selectecedCategory: 'All'
    }
  }

  selectSubjectCategory = (value) => {
    this.setState({selectecedCategory: value})
    this.setFilter('category', value)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectecedCategory !== this.state.selectecedCategory || prevProps !== this.props) {
      if (this.props.classes && this.props.subjects) {
        let subjecCategories = [];
        let grades = []
        let subjects = []
        let classes = Object.entries(this.props.classes)
        classes.map( element => {
          if (!grades.includes(element[1].grade)) {
            grades.push(element[1].grade)
          }
          if (!subjecCategories.includes(element[1].subject_category)) {
            subjecCategories.push(element[1].subject_category)
          }
          let subject = Object.entries(this.props.subjects)
          subject = subject.filter( subject =>
            subject[0] == element[1].subject
          )

          if (subject.length>0) {
            subject = {name: subject[0][1].name, id: subject[0][0]}
          }
          if (!subjecCategories.includes(subject)) {
            //If subject category selected, narrow down the subjects to that category
            if (this.state.selectecedCategory == 'All') {
            subjects.push(subject)
            } else if (this.state.selectecedCategory == element[1].subject_category) {
            subjects.push(subject)
            }
          }
        })
        grades = grades.sort(function (a, b) {
          if (a < b) return -1;
          else if (a > b) return 1;
          return 0;
        });
        subjecCategories = subjecCategories.sort(function (a, b) {
          if (a < b) return -1;
          else if (a > b) return 1;
          return 0;
        });
        subjects = subjects.sort(function (a, b) {
          if (a < b) return -1;
          else if (a > b) return 1;
          return 0;
        });
        this.setState({grades, subjecCategories, subjects})
      }
    }
  }

  setFilter = (type, value) => {
    if (type == 'subject') {
      let data;
      if (value == 'All') {
        data = {name: 'All', id: ""}
      } else {
        let subject;
         subject = Object.entries(this.props.subjects).filter( subject =>
          subject[0] == value
        )
         data = {
          name: subject[0][1].name,
          id: subject[0][0]
        }
      }
      this.props.setFilter(type, data)
    } else if (type == 'teacher') {
      let data;
      if (value == 'All') {
        data = {name: 'All', id: ""}
      } else {
         let teacher = this.props.teachers.filter( teacher =>
          teacher[0] == value
        )
         data = {
          name: teacher[0][1].profile.name+" "+teacher[0][1].profile.last_name,
          id: teacher[0][0]
        }
      }

      this.props.setFilter(type, data)
    } else {
      this.props.setFilter(type, value)
    }
  }

  translateGrade = (grade) => {
    const { t } = this.props
    if (grade) {
      grade = grade.split(' ')
      grade[0] = t(grade[0])
      return grade.join(' ')
    } else {
      return ""
    }
  }

  render() {

    let {grade, category, subject, teacher} = this.props.filters
    let url = this.props.location.split("/")
    let menuLocation = url[1];
    const { t } = this.props

    return (
      <div>
       <Modal
         style={modal}
         bodyStyle={{  maxHeight: '70vh', overflow: 'scroll'}}
         title={t("Filter")}
         visible={this.props.isOpen}
         onCancel={this.props.close}
         footer={false}
         width="300px"
       >
        <p style={{marginLeft: 10}}>{t('Grade')}</p>
        <Select value={grade} defaultValue="All" style={{ width: 250 }} onChange={(value) => this.setFilter('grade', value)}>
          <Option value="All">{t('All')}</Option>
          {this.state.grades && this.state.grades.map( grade => (
            <Option key={grade} value={grade}>{this.translateGrade(grade)}</Option>
          ))}
        </Select>
        <p style={{marginLeft: 10, marginTop: 20}}>{t('Subject group')}</p>
        <Select value={category} defaultValue="All" style={{ width: 250 }} onChange={(value) => this.selectSubjectCategory(value)}>
          <Option value="All">{t('All')}</Option>
          {this.state.subjecCategories && this.state.subjecCategories.map( cat => (
            <Option key={cat} value={cat}>{t(cat)}</Option>
          ))}
        </Select>
        <p style={{marginLeft: 10, marginTop: 20}}>{t('Subject')}</p>
        <Select value={subject.id == "" ? 'All' : subject.id} defaultValue="All" style={{ width: 250 }} onChange={(value) => this.setFilter('subject', value)}>
          <Option value="All">{t('All')}</Option>
          {this.state.subjects && this.state.subjects.map( subject => (
            <Option key={subject.id} value={subject.id}>{subject.name}</Option>
          ))}
        </Select>
        {menuLocation !== 'myclasses' &&
          <div>
            <p style={{marginLeft: 10, marginTop: 20}}>{t('Teacher')}</p>
            <Select value={teacher.id == "" ? 'All' : teacher.id} style={{ width: 250 }} onChange={(value) => this.setFilter('teacher', value)}>
              <Option value="All">{t('All')}</Option>
              {this.props.teachers && this.props.teachers.map( teacher => (
                <Option key={teacher[0]} value={teacher[0]}>{teacher[1].profile.name+" "+teacher[1].profile.last_name}</Option>
              ))}
            </Select>
          </div>
        }
       </Modal>
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
)
export default enhancer(ModalFilter);


const modal = {
  position: 'absolute',
  right: '60px',
}



// WEBPACK FOOTER //
// ./src/components/ModalFilter/index.jsx